import { createAsyncThunk } from "@reduxjs/toolkit"
import { WorkflowSummary } from "../../model/workflows/Workflow.model";
import { RootState } from "../../root-redux/RootState";
import { getRequest } from "../utils/GetRequest";
import { postRequest, postRequestByEnv } from "../utils/PostRequest";
import { Campaign } from "../../model/SPAModels/campaigns/campaign.Model";
import { ENV_PROD } from "../../feature-components/spa-admin/SPAConstants";

export const getWorkflowsBySubKeys_dev = createAsyncThunk<WorkflowSummary[], { subKey: string }, { state: RootState }>('releaseDashboard/getWorkflowsBySubKey_dev', async ({ subKey }, { getState }) => {
    const response = await getRequest<WorkflowSummary[]>(`dev/workflows/details?subKeys=${subKey}`)
    return response.data
});

export const getWorkflowsBySubKeys_uat = createAsyncThunk<WorkflowSummary[], { subKey: string }, { state: RootState }>('releaseDashboard/getWorkflowsBySubKey_uat', async ({ subKey }, { getState }) => {
    const response = await getRequest<WorkflowSummary[]>(`uat/workflows/details?subKeys=${subKey}`)
    return response.data
});

export const getWorkflowsBySubKeys_prod = createAsyncThunk<WorkflowSummary[], { subKey: string }, { state: RootState }>('releaseDashboard/getWorkflowsBySubKey_prod', async ({ subKey }, { getState }) => {
    const response = await getRequest<WorkflowSummary[]>(`prod/workflows/details?subKeys=${subKey}`, ENV_PROD);
    return response.data
});

export type matchingSegmentsPayload = {
    campaignTag?: string,
    orgName: string,
    solutionArea: string,
    solutionPlay: string,
    salesMotion: string,
    segment?: string,
    isMultiSegment: boolean
}

export class SegmentDetails {
    msdyn_name!: string
    msdyn_segmentid?: string
    msdyn_entityfilter?: string
    _msdyn_sequence_value?: string
    "aa.msdyn_name"?: string
}

export class RecsDetails {
    recs_count!: number
	segmentName?: string
	ownerName?: string
}
export class CampaignPipeline {
    total_potential_rev_base?: number
    count?: number
}

export const getMatchingSegments_dev = createAsyncThunk<any, matchingSegmentsPayload, { state: RootState }>('releaseDashboard/getMatchingSegments_dev', async (payload, { getState }) => {
    const response = await postRequest<SegmentDetails[], any>('dev/campaigntaxonomy/fetch/SegmentForCampaign', payload);
    return response.data;
});

export const getMatchingSegments_uat = createAsyncThunk<any, matchingSegmentsPayload, { state: RootState }>('releaseDashboard/getMatchingSegments_uat', async (payload, { getState }) => {
    const response = await postRequest<SegmentDetails[], any>('uat/campaigntaxonomy/fetch/SegmentForCampaign', payload);
    return response.data;
});

export const getMatchingSegments_prod = createAsyncThunk<any, matchingSegmentsPayload, { state: RootState }>('releaseDashboard/getMatchingSegments_prod', async (payload, { getState }) => {
    const response = await postRequestByEnv<SegmentDetails[], any>('prod/campaigntaxonomy/fetch/SegmentForCampaign', payload, ENV_PROD);
    return response.data;
});

const parseRecResponse = (responseData: any) => {
    if (responseData instanceof Array) {
        return responseData.map((rec) => {
            return {
                recs_count: rec.recs_count,
                segmentName: rec["segmentid@OData.Community.Display.V1.FormattedValue"],
                ownerName: rec["owner_id@OData.Community.Display.V1.FormattedValue"]
            } as RecsDetails;
        });
    }
    return [] as RecsDetails[];
}

export const getRecommendationsCount_dev = createAsyncThunk<RecsDetails[], {tag: any, name: any}, { state: RootState }>('releaseDashboard/getRecommendationsCount_dev', async (details, { getState }) => {
    const response = await getRequest<any>(`dev/campaigntaxonomy/fetch/recommendationCount/${details.tag}/${details.name}`);
    return parseRecResponse(response.data["value"]);
});

export const getRecommendationsCount_uat = createAsyncThunk<RecsDetails[], {tag: any, name: any}, { state: RootState }>('releaseDashboard/getRecommendationsCount_uat', async (details, { getState }) => {
    const response = await getRequest<any>(`uat/campaigntaxonomy/fetch/recommendationCount/${details.tag}/${details.name}`);
    return parseRecResponse(response.data["value"]);
});

export const getRecommendationsCount_prod = createAsyncThunk<RecsDetails[], {tag: any, name: any}, { state: RootState }>('releaseDashboard/getRecommendationsCount_prod', async (details, { getState }) => {
    const response = await getRequest<any>(`prod/campaigntaxonomy/fetch/recommendationCount/${details.tag}/${details.name}`,ENV_PROD);
    return parseRecResponse(response.data["value"]);
});
export const getCampaignPipeline_dev = createAsyncThunk<CampaignPipeline,Campaign, { state: RootState }>('releaseDashboard/getCampaignPipeline_dev', async (campaign,{getState} ) => {
    const response = await postRequest<CampaignPipeline, Campaign>(`dev/campaigntaxonomy/fetch/CampaignPipeline`, campaign );
    return response.data;
});
export const getCampaignPipeline_uat = createAsyncThunk<CampaignPipeline,Campaign, { state: RootState }>('releaseDashboard/getCampaignPipeline_uat', async (campaign,{getState} ) => {
    //change this to uat when releasing to ssv2
    const response = await postRequest<CampaignPipeline, Campaign>(`uat/campaigntaxonomy/fetch/CampaignPipeline`,  campaign );
    return response.data;

});
export const getCampaignPipeline_prod = createAsyncThunk<CampaignPipeline,Campaign, { state: RootState }>('releaseDashboard/getCampaignPipeline_prod', async (campaign,{getState} ) => {
    const response = await postRequestByEnv<CampaignPipeline, Campaign>(`prod/campaigntaxonomy/fetch/CampaignPipeline`,  campaign,ENV_PROD );
    return response.data;

});
export const getAssignmentRuleDetails_dev = createAsyncThunk<any, string, { state: RootState }>('releaseDashboard/getAssignmentRuleDetails_dev', async (segmentName, { getState }) => {
    const response = await postRequest<any, any>(`dev/campaigntaxonomy/fetch/AssignmentRuleForCampaign`, { segmentName });
    return {segmentName, data: response.data}
});

export const getAssignmentRuleDetails_uat = createAsyncThunk<any, string, { state: RootState }>('releaseDashboard/getAssignmentRuleDetails_uat', async (segmentName, { getState }) => {
    const response = await postRequest<any, any>(`uat/campaigntaxonomy/fetch/AssignmentRuleForCampaign`, { segmentName });
    return {segmentName, data: response.data}
});

export const getAssignmentRuleDetails_prod = createAsyncThunk<any, string, { state: RootState }>('releaseDashboard/getAssignmentRuleDetails_prod', async (segmentName, { getState }) => {
    const response = await postRequestByEnv<any, any>(`prod/campaigntaxonomy/fetch/AssignmentRuleForCampaign`, { segmentName }, ENV_PROD);
    return {segmentName, data: response.data}
});

export const getPreReleaseAssignments_uat = createAsyncThunk<any, string, { state: RootState }>('releaseDashboard/getPreReleaseAssignments_uat', async (campaignId,{getState}) => {
    const response = await getRequest<any>(`uat/campaigns/${campaignId}/assignments`);
    return response.data
});
export const refreshPreReleaseAssignments_uat = createAsyncThunk<any, {campaignId: string, type: number}, { state: RootState }>('releaseDashboard/refreshPreReleaseAssignments_uat', async ({campaignId, type}) => {
    const response = await postRequest<any, any>(`uat/campaigns/${campaignId}/${type}/preRelease/refresh`, { campaignId, type });
    return response.data
});